import React from 'react'

function Container({children}) {
  return <div className='w-full max-w-[90vw] mx-auto px-4 font-outfit'>{children}</div>;
  
}

export default Container